<template>
  <div class="divBox">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <div class="container">
          <el-form inline size="small" :label-position="labelPosition" label-width="100px">
            <el-row>
              <el-col :span="24">

                <el-form-item label="余额排序：">

                  <el-radio-group v-model="userFrom.sort" type="button" @change="getList(1)">
                    <el-radio-button
                      label="now_money DESC"
                    >降序
                    </el-radio-button>
                    <el-radio-button
                      label="now_money ASC"
                    >升序
                    </el-radio-button>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="甄豆排序：">

                  <el-radio-group v-model="userFrom.sort" type="button" @change="getList(1)">
                    <el-radio-button
                      label="integral DESC"
                    >降序
                    </el-radio-button>
                    <el-radio-button
                      label="integral ASC"
                    >升序
                    </el-radio-button>
                  </el-radio-group>
                </el-form-item>

                <el-input style="width: 180px" v-model="userFrom.nickname" placeholder="请输入昵称" clearable
                          class="selWidth"/>
                <el-input style="width: 180px" v-model="userFrom.phone" placeholder="请输入手机号" clearable
                          class="selWidth"/>
                <el-input style="width: 180px" v-model="userFrom.uid" placeholder="请输入用户ID" clearable
                          class="selWidth"/>
                <el-button type="primary" icon="ios-search" label="default" class="mr15" size="small"
                           @click="userSearchs">搜索
                </el-button>
                <el-button class="ResetSearch mr10" size="small" type="reset" @click="reset('userFrom')">重置
                </el-button>

              </el-col>
            </el-row>
          </el-form>
        </div>
        <cards-data :card-lists="cardLists" style="margin-top: 20px"/>
      </div>
      <el-table v-loading="listLoading" :data="tableData.data" style="width: 100%" size="small" highlight-current-row
                @selection-change="handleSelectionChange">
        <!-- <el-table-column type="selection" width="55" /> -->
        <el-table-column prop="uid" label="ID" min-width="60"/>
        <el-table-column label="头像" min-width="50">
          <template slot-scope="scope">
            <div class="demo-image__preview">
              <el-image style="width: 36px; height: 36px" :src="scope.row.avatar ? scope.row.avatar : moren"
                        :preview-src-list="[scope.row.avatar || moren]"/>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="昵称" min-width="150">
          <template slot-scope="{row}">
            <div class="acea-row">
              <i v-show="row.sex===1" class="el-icon-male mr5"
                 style="font-size: 15px; margin-top: 3px; color:#2db7f5;"/>
              <i v-show="row.sex===2" class="el-icon-female mr5"
                 style="font-size: 15px; margin-top: 3px; color:#ed4014;"/>
              <div v-text="row.nickname"/>
            </div>
          </template>
        </el-table-column>
        <!--            <el-table-column prop="is_svip" label="付费会员" min-width="120">-->
        <!--                 <template slot-scope="{row}">-->
        <!--                    <span>{{row.is_svip > 0 ? "是" : "否"}}</span>-->
        <!--                </template>-->
        <!--            </el-table-column>-->
        <el-table-column prop="phone" label="手机号" min-width="120"/>
        <el-table-column label="等级" min-width="100">
          <template slot-scope="{row}">
            <span>{{ row.member ? row.member.brokerage_name : '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="now_money" label="余额" sortable min-width="100"
                         :sort-method="(a,b)=>{return a.now_money - b.now_money}"/>
        <el-table-column prop="integral" label="甄豆" min-width="120"/>
        <el-table-column label="操作" min-width="130" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="onDetails(scope.row.uid)">余额详情</el-button>
            <el-button type="text" size="small" v-if="!scope.row.cancel_time" @click="setMoney(scope.row)">设置余额
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="block">
        <el-pagination :page-sizes="[20, 40, 60, 80]" :page-size="userFrom.limit" :current-page="userFrom.page"
                       layout="total, sizes, prev, pager, next, jumper" :total="tableData.total"
                       @size-change="handleSizeChange" @current-change="pageChange"/>
      </div>
    </el-card>
    <!--账户详情-->
    <el-dialog v-if="uid" title="用户详情" :visible.sync="visibleDetail" width="1000px" :before-close="Close">
      <user-details v-if="visibleDetail" ref="userDetails" :uid="uid" :cancel-time="cancel_time"/>
    </el-dialog>
  </div>
</template>

<script>
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
import {
  userLstApi,
  changeGroupApi,
  changelabelApi,
  changeNowMoneyApi,
  changeNowIntegralApi,
  batchChangeGroupApi,
  batchChangelabelApi,
  userUpdateApi,
  groupLstApi,
  labelLstApi,
  modifyUserReferrer,
  modifyUserPassword,
  changeMemberApi,
  createUserApi,
  giveMemberApi, authorityStatusApi, userSpreadImgApi, userBalanceLstApi, userBalanceCardListApi
} from '@/api/user'
import newsCategory from '@/components/newsCategory/index.vue'
import {communityDetailApi, communityStatusApi} from "@/api/community";
import userDetails from "@/views/accounts/extract/userDetails";
import {recoveryOrderCardListApi} from "@/api/recovery";
import cardsData from "@/components/cards";

export default {
  name: 'UserBalanceList',
  components: {
    cardsData,
    userDetails,
  },
  data() {
    return {
      moren: require("@/assets/images/f.png"),
      timeVal: [],
      collapse: false,
      visibleDetail: false,
      dialogVisible: false,
      maxCols: 3,
      isShowSend: true,
      visible: false,
      loading: false,
      user_type: '',
      tableData: {
        data: [],
        total: 0
      },
      listLoading: true,
      multipleSelection: [],
      ruleForm: [],
      ids: '',
      wechatIds: '',
      uid: '',
      labelPosition: 'right',
      userProps: {
        children: 'children',
        label: 'name',
        value: 'name'
      },
      formData: {'spread_image': ''},
      userFrom: {
        label_id: '',
        user_type: '',
        sex: '',
        is_promoter: '',
        country: '',
        pay_count: '',
        user_time_type: '',
        user_time: '',
        nickname: '',
        phone: '',
        province: '',
        city: '',
        page: 1,
        limit: 20,
        group_id: ''
      },
      address: [],
      grid: {
        xl: 8,
        lg: 12,
        md: 12,
        sm: 24,
        xs: 24
      },
      grid2: {
        xl: 18,
        lg: 16,
        md: 12,
        sm: 24,
        xs: 24
      },
      grid3: {
        xl: 8,
        lg: 12,
        md: 12,
        sm: 24,
        xs: 24
      },
      addresData: [],
      groupList: [],
      labelLists: [],
      chkName: '',
      checkedPage: [],
      allCheck: false,
      cancel_time: null,
      cardLists: [],

    }
  },
  mounted() {
    this.getList('')
  },
  methods: {
    userSearchs() {
      this.getList(1)
    },
    // 创建用户
    // 账户详情
    onDetails(id) {
      this.uid = id
      this.cancel_time = this.tableData.data.find(item => item.uid === id).cancel_time
      this.visibleDetail = true
    },
    Close() {
      this.visibleDetail = false
    },

    handleSelectionChange(val) {
      this.multipleSelection = val
      const data = []
      const wechatData = []
      this.multipleSelection.map((item) => {
        data.push(item.uid)
        wechatData.push(item.wechat_user_id)
      })
      this.ids = data.join(',')
      this.wechatIds = wechatData.join(',')
    },
    // 修改分组
    setGroup(row) {
      this.$modalForm(changeGroupApi(row.uid)).then(() => this.getList(''))
    },
    // 批量分组
    batchGroup() {
      if (this.checkedIds.length === 0) return this.$message.warning('请先选择用户')
      this.$modalForm(batchChangeGroupApi({
        ids: (this.checkedIds).join(",")
      }))
    },
    // 批量标签
    batchlabel() {
      if (this.checkedIds.length === 0) return this.$message.warning('请先选择用户')
      this.$modalForm(batchChangelabelApi({
        ids: (this.checkedIds).join(",")
      }))
    },
    // 修改标签
    setLabel(row) {
      this.$modalForm(changelabelApi(row.uid)).then(() => this.getList(''))
    },
    // 编辑会员等级
    setMember(row) {
      this.$modalForm(changeMemberApi(row.uid)).then(() => this.getList(''))
    },
    // 赠送付费会员
    giveMember(row) {
      this.$modalForm(giveMemberApi(row.uid)).then(() => this.getList(''))
    },
    giveAuthority(row, status) {
      authorityStatusApi(row.uid, status).then(({message}) => {
        this.$message.success(message)
        this.getList('')
      }).catch(({message}) => {
        this.$message.error(message)
      })
    },
    // 修改推荐人
    setModify(row) {
      this.$modalForm(modifyUserReferrer(row.uid)).then(({message}) => {
        this.$message.success(message)
        this.getList('');
      });
    },
    // 修改密码
    setPassword(row) {
      this.$modalForm(modifyUserPassword(row.uid)).then(() => this.getList(''));
    },
    // 修改余额
    setMoney(row) {
      this.$modalForm(changeNowMoneyApi(row.uid)).then(() => this.getList(''))
    },
    setSpreadImg(id) {
      this.uid = id;
      this.dialogVisible = true;
      this.isExamine = false;
      userSpreadImgApi(id).then((res) => {
        this.formData = res.data
      }).catch(({message}) => {
        this.$message.error(message)
      })
    },
    handleClose() {
      this.dialogVisible = false
    },
    // 修改甄豆余额
    changeIntegral(row) {
      this.$modalForm(changeNowIntegralApi(row.uid)).then(() => this.getList(''))
    },
    // 列表
    getList(num) {
      this.listLoading = true
      this.userFrom.page = num ? num : this.userFrom.page;
      this.userFrom.is_authority = 0
      userBalanceLstApi(this.userFrom).then(res => {
        this.tableData.data = res.data.list
        this.tableData.total = res.data.count
        this.listLoading = false
        this.getCardList()
      }).catch(res => {
        this.listLoading = false
        this.$message.error(res.message)
      })
    },
    getCardList() {
      userBalanceCardListApi(this.tableFrom)
        .then((res) => {
          this.cardLists = res.data;
        })
        .catch((res) => {
          this.$message.error(res.message);
        });
    },
    pageChange(page) {
      this.userFrom.page = page
      this.getList('')
    },
    handleSizeChange(val) {
      this.userFrom.limit = val
      this.getList('')
    },
    // 编辑
    onEdit(id) {
      this.$modalForm(userUpdateApi(id)).then(() => this.getList(''))
    },
    // 重置
    reset() {
      this.userFrom = {
        label_id: '',
        user_type: '',
        sex: '',
        is_promoter: '',
        country: '',
        pay_count: '',
        user_time_type: '',
        user_time: '',
        nickname: '',
        province: '',
        city: '',
        page: 1,
        limit: 20,
        group_id: ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.check {
  color: #00a2d4;
}

.selWidth {
  // width: 100% !important;
}

.dia {
  /deep/ .el-dialog__body {
    height: 700px !important;
  }
}

.text-right {
  text-align: right;
}

.container {
  min-width: 821px;

  /deep/ .el-form-item {
    width: 100%;
  }

  /deep/ .el-form-item__content {
    width: 72%;
  }
}

.vipName {
  color: #dab176
}

.el-dropdown-link {
  cursor: pointer;
  color: #409EFF;
  font-size: 12px;
}

.el-icon-arrow-down {
  font-size: 12px;
}

.demo-table-expand {
  font-size: 0;
}

.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}

.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 33.33%;
}

/deep/ [type=reset],
[type=submit],
button,
html [type=button] {
  -webkit-appearance: none !important;
}
</style>
